module.exports = __webpack_public_path__ + "img/SES_220411100.86416d3c.jpg";